import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { processesService } from "services/processesService";
import { generatePrintCaHtml } from "./ProcessPrintCaTemplate";

export function ProcessPrintCaPage() {
  const { id } = useParams();
  const [html, setHtml] = useState("");

  useEffect(() => {
    async function fetchHtml() {
      const caDetails = await processesService.getPrintCaDetails(id);
      const generatedHtml = await generatePrintCaHtml(caDetails);
      setHtml(generatedHtml);
    }
    fetchHtml();
  }, [id]);

  return <div dangerouslySetInnerHTML={{ __html: html }} />;
}